import { render } from "./GestionCamareros.vue?vue&type=template&id=cc4fea4e&scoped=true"
import script from "./GestionCamareros.vue?vue&type=script&lang=js"
export * from "./GestionCamareros.vue?vue&type=script&lang=js"

import "./GestionCamareros.vue?vue&type=style&index=0&id=cc4fea4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4fea4e"]])

export default __exports__